// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cursor_wrapper__2MfYh","circle":"Cursor_circle__3TxJu","state2":"Cursor_state2__24jwG","hidden":"Cursor_hidden__Dbpmn","text":"Cursor_text__3D3c8"};